import classNames from "classnames";
import { includes, map } from "lodash-es";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { useLanguageSelections } from "~/queries";
import { Button, FlagIcon, Modal } from "~/ui/components";
import { LanguageContext } from "~/ui/context/language";
import { useScreenMd } from "~/utils";
export interface SelectLanguageProps {
  onClose: () => unknown;
  isOpened: boolean;
}

export const SelectLanguage: React.FC<SelectLanguageProps> = ({
  onClose,
  isOpened,
}) => {
  const context = useContext(LanguageContext);
  const isDesktop = useScreenMd();
  const { data: languages } = useLanguageSelections();
  const languagesToFormat = [
    "el_GR",
    "da_DK",
    "fi_FI",
    "hi_IN",
    "is_IS",
    "it_IT",
    "no_NO",
    "pl_PL",
    "pt_PT",
    "ru_RU",
    "sv_SE",
  ];
  return (
    <Modal
      open={isOpened}
      onClose={onClose}
      header={
        <div>
          <FormattedMessage defaultMessage="Select language" id="eVlu1R" />
        </div>
      }
      className={classNames(!isDesktop && "w-90 mg-0-auto")}
    >
      <div
        className={classNames(
          isDesktop ? "grid-1-4 gap-sm" : "flex flex-col items-center gap-md"
        )}
      >
        {map(
          languages,
          (l: { key: string; name: string; isDefault: boolean }) => {
            const flagKey = includes(l.key, "_") ? l.key.substring(3) : l.key;
            const providerKey = l.key;
            let localeKey = "";
            if (includes(languagesToFormat, l.key)) {
              localeKey = l.key.substring(3);
            } else {
              localeKey = l.key;
            }
            if (l.key && l.key !== "UAE") {
              return (
                <Button
                  onClick={() => {
                    context.changeLanguage(providerKey, localeKey);
                    onClose();
                  }}
                  key={l.key}
                  variant={
                    context.language.providerKey === providerKey
                      ? "success"
                      : "dark"
                  }
                  className="flex items-center gap-xl w-100"
                >
                  <FlagIcon
                    nationality={l.key === "en" ? "US" : flagKey}
                    size={20}
                  />
                  <span
                    className={
                      context.language.providerKey === providerKey
                        ? "text-dark"
                        : "text-white"
                    }
                  >
                    {l.name}
                  </span>
                </Button>
              );
            } else {
              return null;
            }
          }
        )}
      </div>
    </Modal>
  );
};
